import { fork } from 'redux-saga/effects';
import { servicesSaga } from './sagas/services.saga';
import { templatesSaga } from './sagas/templates.saga';
import { surveysSaga } from './sagas/surveys.saga';

export function* templatesMainSaga() {
	yield fork(servicesSaga);
	yield fork(templatesSaga);
	yield fork(surveysSaga);
}
